<blitz-top [title]="title" [banner]="banner"></blitz-top>
<section class="page page-not-found">
  <div>{{ 'Not Found.Line 1' | translate:lang }}</div>
  <div>{{ 'Not Found.Line 2' | translate:lang }}</div>
  <div>CLUB DE PRESSE BLITZ <sup>MC</sup></div>
</section>
